import React from 'react';
import { useLocation } from 'react-router-dom';
import { Package, Bell, Search, User } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { UserMenu } from '@/components/auth/UserMenu';
import { useAuth } from '@/components/auth/AuthProvider';

const getPageTitle = (pathname: string): string => {
  const routes: Record<string, string> = {
    '/': 'Dashboard',
    '/orders': 'Orders',
    '/archived-orders': 'Archived Orders',
    '/analytics': 'Reports',
    '/profile': 'Profile',
    '/master-products': 'Products',
    '/suppliers': 'Suppliers',
    '/sync-manager': 'Unified Sync Center',
    '/executive-reporting': 'Executive Reports',
  };
  
  // Check for dynamic routes
  if (pathname.includes('/order-workstation/')) return 'Workstation';
  if (pathname.includes('/order/')) return 'Order Details';
  if (pathname.includes('/master-products/')) return 'Product Details';
  
  return routes[pathname] || 'Foodland Eye';
};

export const MobileHeader = () => {
  const location = useLocation();
  const { profile } = useAuth();
  const pageTitle = getPageTitle(location.pathname);

  return (
    <header className="sticky top-0 z-header bg-surface/95 backdrop-blur-sm border-b border-border">
      <div className="flex items-center justify-between h-14 px-4">
        {/* Left: Logo and Title */}
        <div className="flex items-center gap-3 min-w-0 flex-1">
          <Package className="h-6 w-6 text-primary flex-shrink-0" />
          <div className="min-w-0">
            <h1 className="text-lg font-semibold truncate">{pageTitle}</h1>
            {profile?.role && (
              <p className="text-xs text-muted-foreground capitalize">
                {profile.role}
              </p>
            )}
          </div>
        </div>

        {/* Right: Action Buttons */}
        <div className="flex items-center gap-1">
          <Button
            variant="ghost"
            size="sm"
            className="h-9 w-9 p-0"
          >
            <Search className="h-4 w-4" />
          </Button>
          <Button
            variant="ghost"
            size="sm"
            className="h-9 w-9 p-0 relative"
          >
            <Bell className="h-4 w-4" />
            {/* Notification badge */}
            <span className="absolute -top-1 -right-1 h-3 w-3 bg-destructive rounded-full text-xs text-destructive-foreground flex items-center justify-center">
              2
            </span>
          </Button>
          <UserMenu />
        </div>
      </div>
    </header>
  );
};